/**
 * Copied from jobseeker-ux/jspl/packages/documents/src/utils/getFileExtension.ts
 * Extracts and returns the file extension from a given filename.
 * @param fileName - The name of the file to get the extension from
 * @returns The lowercase file extension without the dot, or an empty string if no extension or filename is provided
 */
export const getFileExtension = (fileName: string): string => {
  if (!fileName || !fileName.includes(".")) return "";

  return fileName.split(".").pop()?.toLowerCase() || "";
};
